import React from "react";
import { ArrowLeftCircle } from "react-feather";
import { BtnText } from '@saladbob/sassafras'

type Props = {
    onClick: () => void;
    children?: React.ReactNode;
    [key: string]: any;
};

const BackBtn: React.FC<Props> = ({ onClick, children, ...props }) => {
    return (
        <BtnText
            type="button"
            onClick={onClick}
            txtColor="neutral"
            icon={<ArrowLeftCircle size="32" />}
            {...props}
        >
            {children || 'Back'}
        </BtnText>
    );
}

export default BackBtn;